






import Vue from "vue";
import { BREAKPOINTS } from "@tt-app/constants";

import FeedbackButton from "@tt-app/components/feedback/FeedbackButton.vue";
import FeedbackCard from "@tt-app/components/feedback/FeedbackCard.vue";

interface Data {
  screenWidth: number;
}

interface Methods {
  handleClose: () => void;
  updateScreenWidth: () => void;
}

interface Computed {
  onMobile: boolean;
}

interface Props {
  logId: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FeedbackPopup",

  components: {
    FeedbackCard,
    FeedbackButton
  },

  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },

  props: {
    logId: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      screenWidth: (window as any).innerWidth
    };
  },

  computed: {
    onMobile() {
      return this.screenWidth < BREAKPOINTS.MOBILE;
    }
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },

    updateScreenWidth() {
      this.screenWidth = (window as any).innerWidth;
    }
  }
});
